import {useCallback} from 'react';

import NiceModal, {useModal} from '@ebay/nice-modal-react';
import {Observer} from 'mobx-react';

import type {ConferencePreviewSettings} from '@yourcoach/shared/modules/conference';

import {useI18n} from '@yourcoach/i18n';
import {COMMAND} from '@yourcoach/shared/services/entity-action/utils';

import * as S from './styles';

export type ResolveType = ConferencePreviewSettings | symbol;

type PropsType = {
  isStart?: boolean;
};

export const ConferencePreviewModal = NiceModal.create<PropsType>(
  ({isStart}: PropsType) => {
    const {t} = useI18n();
    const modal = useModal();

    const onRequestClose = useCallback(() => {
      modal.resolve(COMMAND.CANCEL);
      modal.hide();
    }, [modal]);

    const onJoinButtonClick = useCallback(
      (settings: ConferencePreviewSettings) => {
        modal.resolve(settings);
        modal.hide();
      },
      [modal],
    );

    return (
      <Observer>
        {() => (
          <S.Modal
            bodyClassName={'body'}
            isOpen={modal.visible}
            onAfterClose={modal.remove}
            onRequestClose={onRequestClose}
            title={t('shared:Conference.preview.title')}
          >
            <S.ConferencePreviewContainer
              isStart={isStart}
              onJoinButtonClick={onJoinButtonClick}
            />
          </S.Modal>
        )}
      </Observer>
    );
  },
);
